import useReveal from "@/hooks/useReveal";

const services = [
  {
    n: "01",
    title: "Audience Monetisation",
    body: "Turning quiet followings into paying customers — pricing, positioning, paid offers and recurring revenue rails.",
  },
  {
    n: "02",
    title: "Product Launches",
    body: "End-to-end launches: positioning, sales pages, email sequences, ad creatives — engineered for the first six figures.",
  },
  {
    n: "03",
    title: "Funnel Build-Out",
    body: "High-converting funnels stitched into your existing platforms. From cold scroll to checkout, instrumented and tested.",
  },
  {
    n: "04",
    title: "Growth Strategy",
    body: "The unglamorous behind-the-scenes operating system — content cadence, retention loops, distribution maps.",
  },
];

export default function WhatIDo() {
  const ref = useReveal();
  return (
    <section
      id="services"
      data-testid="what-i-do-section"
      ref={ref}
      className="reveal relative px-6 md:px-12 py-28 md:py-40 bg-[#0A0A0A] border-t border-[#2E2A28]"
    >
      <div className="grid grid-cols-12 gap-10 max-w-7xl mx-auto">
        <div className="col-span-12 md:col-span-4 md:sticky md:top-24 self-start">
          <div className="overline section-mark mb-6">What I Do</div>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light leading-[1.05] tracking-tight text-[#F2E7DF]">
            Four levers. <br />
            <span className="italic text-[#A19D9B]">Pulled in the dark.</span>
          </h2>
          <p className="mt-6 text-[#A19D9B] text-base max-w-sm leading-relaxed">
            I don&apos;t run a content channel. I don&apos;t post case studies. I work on a
            tight roster — and I keep my hands on every line of copy, every offer,
            every send.
          </p>
        </div>
        <div className="col-span-12 md:col-span-8">
          <ul className="divide-y divide-[#2E2A28]">
            {services.map((s) => (
              <li
                key={s.n}
                data-testid={`service-${s.n}`}
                className="group py-10 md:py-12 grid grid-cols-12 gap-4 transition-colors duration-500 hover:bg-[#101010]"
              >
                <div className="col-span-2 md:col-span-1 font-mono-detail text-[#E5C16C] text-sm pt-1">
                  {s.n}
                </div>
                <div className="col-span-10 md:col-span-11">
                  <h3 className="font-serif-display text-2xl md:text-3xl font-light text-[#F2E7DF] group-hover:text-white transition-colors duration-500">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#A19D9B] text-base md:text-lg max-w-2xl leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
